import type { PlanChangePlanSummary } from '../../../../services/plan-change.service';

/**
 * CWS-1579: a family member pays the list price less their family discount. The list price is
 * shown beside it only when the two differ, so a primary or a plate outside a family sees one price.
 */
export function familyListPrice(plan: PlanChangePlanSummary | null | undefined): number | null {
  const list = plan?.list_price;
  const paid = plan?.monthly_price;
  if (list === null || list === undefined || paid === null || paid === undefined) return null;
  return Math.abs(Number(list) - Number(paid)) >= 0.005 ? Number(list) : null;
}
